import { StrictMode, useEffect } from "react";
import * as Sentry from "@sentry/react";

import i18n from "../i18n";
import { isRtlLanguage, normalizeLanguageCode } from "../locales";
import App from "./App";

const RootApp = () => {
    useEffect(() => {
        const applyLanguageMetadata = (languageCode?: string) => {
            const normalizedLanguageCode = normalizeLanguageCode(languageCode || i18n.resolvedLanguage || i18n.language || "en");
            const direction = isRtlLanguage(normalizedLanguageCode) ? "rtl" : "ltr";

            document.documentElement.lang = normalizedLanguageCode;
            document.documentElement.dir = direction;
            document.body.dir = direction;
        };

        applyLanguageMetadata();
        i18n.on("languageChanged", applyLanguageMetadata);

        return () => {
            i18n.off("languageChanged", applyLanguageMetadata);
        };
    }, []);

    return (
        <StrictMode>
            <Sentry.ErrorBoundary fallback={<p>{i18n.t("unexpectedErrorOccurred")}</p>} showDialog>
                <App />
            </Sentry.ErrorBoundary>
        </StrictMode>
    );
};

export default RootApp;
